/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from 'react'
import ErrorLabel from 'ui/atoms/ErrorLabel'
import SemiBoldText from 'ui/atoms/SemiBoldText'

import { useFormAppearance } from '@/hooks/useFormAppearance'
import cn from '@/utils/tailwind/cn'

import Tooltip from './atoms/Tooltip'
import Icons from './Icons'
import Theme from './theme'

type Props = {
  isRequired?: boolean
  containerClassName?: string
  isOfficeUse?: boolean
  className?: string
  htmlFor?: string
}

type HelperTextProps = {
  className?: string
  marginTop?: number
}

/**
 * @deprecated
 */
export function QuestionTitle({
  isRequired,
  children,
  containerClassName,
  isOfficeUse,
  className,
}: React.PropsWithChildren<Props>) {
  const { hasQuestionColor } = useFormAppearance()

  return (
    <div className={cn('mb-1', containerClassName, className)}>
      {/* @ts-ignore */}
      <SemiBoldText className={cn(hasQuestionColor && 'question-text')}>
        {isOfficeUse ? (
          <Tooltip mouseEnterDelay={0.7} title="Office use only">
            <i>
              <Icons.BuildingOffice
                className="mr-1 inline-block h-4 w-4"
                stroke={Theme.color.officeUseBorder}
              />
            </i>
          </Tooltip>
        ) : null}
        {children}
      </SemiBoldText>
      {isRequired && <ErrorLabel> *</ErrorLabel>}
    </div>
  )
}

export function HelperText({
  className,
  children,
  marginTop = 1,
}: React.PropsWithChildren<HelperTextProps>) {
  return (
    children && (
      <div
        className={cn(
          'question-help-text text-xs italic text-gray-400',
          className
        )}
        style={{
          marginTop: `${marginTop * 4}px`,
        }}
      >
        {children}
      </div>
    )
  )
}

const Text = {
  HelperText,
  QuestionTitle,
}

export default Text
